import { render, staticRenderFns } from "./SalonStylistReviewList.vue?vue&type=template&id=4a0567b0&scoped=true"
import script from "./SalonStylistReviewList.vue?vue&type=script&lang=js"
export * from "./SalonStylistReviewList.vue?vue&type=script&lang=js"
import style0 from "./SalonStylistReviewList.vue?vue&type=style&index=0&id=4a0567b0&prod&lang=scss"
import style1 from "./SalonStylistReviewList.vue?vue&type=style&index=1&id=4a0567b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0567b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VTab,VTabs})
